module.exports = __webpack_public_path__ + "static/img/partner2.c3f8681.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/partner2.png
// module id = PGLm
// module chunks = 0